<template>
  <div class="item">
    <div class="item-body">
      <div
        v-if="!mode || mode !== 'view'"
        class="delete-cart"
        @click="deleteCart()">
        <i class="fa fa-times" />
      </div>
      <div class="item-left">
        <img
          :src="base_url + vatpham.product_image"
          width="100%"
          alt=""
          @error="replaceByDefault">
      </div>
      <div class="item-right">
        <div class="item-info">
          <div class="name-item">{{ vatpham.product_name }}</div>
          <div class="price">
            <b v-if="mode && mode === 'view'">Số lượng: x {{ vatpham.count }}</b>
          </div>
          <div class="price">
            <b v-if="mode && mode === 'view'">Tổng số tiền thanh toán: {{ vatpham.total_cost_sale }} đ</b>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ApiConfig from "../../communicate/ApiConfig";
  import defaultImage from '../../assets/images/default.png';

  export default {
    name: "HistoryOrderItem",
    props: ['vatpham', 'mode'],
    data() {
      return {
        base_url: ApiConfig.base_url
      }
    },
    methods: {
      replaceByDefault(e) {
        e.target.src = defaultImage;
      }
    }
  }
</script>

<style scoped>
  .item-left {
    width: 30%;
  }
  .item-right {
    width: 70%;
  }
  .item {
    padding: 8px;
    width: 100%;
  }

  .delete-cart {
    position: absolute;
    right: 0;
    top: 0;
    font-size: 12px;
    cursor: pointer;
  }

  .item-body {
    position: relative;
  }

  .item .item-body .item-right {
    display: table;
  }
  .item .item-body .item-right .item-info {
    padding: 8px;
    display: table-cell;
    vertical-align: middle;
  }
  .item .item-body .item-right .item-info .name-item {
    font-size: 0.9rem;
    font-weight: bold;
  }
  .item .item-body .item-right .item-info .sale-price {
    color: #FF595A;
    font-size: 14px;
    margin-top: 5px;
  }
  .item .item-body .item-right .item-info .original-price {
    color: gray;
    font-size: 13px;
    margin-top: 5px;
    margin-left: 3px;
    text-decoration: line-through;
  }

  .price {
    font-size: 14px;
    line-height: 28px;
  }
</style>



// WEBPACK FOOTER //
// src/components/history/HistoryOrderItem.vue